import React, { ReactNode } from 'react';

import { Button, Modal } from '@/components';
import { useTranslation } from 'react-i18next';

import styles from './Modals.module.css';

interface DisconnectAccountModalProps {
  onNext: () => void;
  onClose: () => void;
  isLoading?: boolean;
  platform: {
    icon: ReactNode;
    name: string;
  };
}

function DisconnectAccountModal({
  onNext,
  platform,
  onClose,
  isLoading
}: DisconnectAccountModalProps) {
  const { t } = useTranslation();

  return (
    <Modal modalStyles={{ maxWidth: '480px' }} handleClose={onClose}>
      <div className={styles.modal}>
        <h2 className={`${styles.modalTitle} ${styles.BottomMarginSm}`}>
          {t('account.accountsSection.modalTitle')}
        </h2>
        <div className={`${styles.modalDescription} ${styles.mb40}`}>
          {t('account.accountsSection.modalSubtitle')}
        </div>

        <div className={styles.modalBody}>
          <div className={styles.modalPlatform}>
            {platform.icon}
            {platform.name}
          </div>
        </div>
        <div className={styles.modalButton}>
          <Button theme="cta" onClick={onNext} isLoading={isLoading}>
            {t('account.accountsSection.button')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default DisconnectAccountModal;
